import { Instance, types } from 'mobx-state-tree';

const ToolsConfigItem = types.model({
  name: types.string,
  label: types.optional(types.string, ''),
  selected: types.optional(types.boolean, false),
});

export interface IToolsConfigItem extends Instance<typeof ToolsConfigItem> {}
export default ToolsConfigItem;
